<script context='module' lang="ts">
  import { OidcContext, isLoading, isAuthenticated as _isAuthenticated, idToken, userInfo } from '@dopry/svelte-oidc'
  import { onMount, onDestroy, tick } from 'svelte'

  export const isAuthenticated = _isAuthenticated
</script>

<script lang="ts">

  const testing = location.search.includes('cy=1')
  const oidc = {
    issuer: 'process.env.OIDC_ISSUER',
    clientId: 'process.env.OIDC_CLIENT_ID',
    redirectUri: 'process.env.OIDC_REDIRECT_URI',
    postLogoutRedirect: 'process.env.OIDC_POST_LOGOUT_REDIRECT',
  }

  async function handleOnMount() {
    if (!testing) return
    await tick()
    isAuthenticated.set(true)
    isLoading.set(false)
    const token = sessionStorage.getItem('.token')
    idToken.set(token)
    userInfo.set({ given_name: 'Mocked', family_name: 'User' })
  }

  async function handleOnDestroy() {
    if (!testing) return
    idToken.set('')
    isAuthenticated.set(false)
  }

  onMount(handleOnMount)
  onDestroy(handleOnDestroy)
</script>

{#if testing}
  <slot />
{:else}
  <OidcContext
    issuer={oidc.issuer}
    client_id={oidc.clientId}
    redirect_uri={oidc.redirectUri}
    post_logout_redirect_uri={oidc.postLogoutRedirect}
  >
    <slot />
  </OidcContext>
{/if}

